module.exports = __webpack_public_path__ + "img/magic-stick.3436e846.svg";